
    <div class="basic-card">
      <span class="basic-card__title basic-card__title--bottom-space">
        {{ title }}
      </span>
      <p class="basic-card__description">{{ description }}</p>
    </div>
  